import { render, staticRenderFns } from "./ContractPreviewDialogue.vue?vue&type=template&id=23de4f60&"
import script from "./ContractPreviewDialogue.vue?vue&type=script&lang=ts&"
export * from "./ContractPreviewDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports